module.exports = __webpack_public_path__ + "assets/img/111.c2e8b8ab.jpg";